// extracted by mini-css-extract-plugin
export default {"block":"styles_block__yIQAk","title":"styles_title__1D70l","overviews":"styles_overviews__WjwYS","overview":"styles_overview__Ratg-"};